import { React, Component, Container, Route, _ } from "utils";
import { JobStore, FairStore, Creators, App } from "model";
import { Back, JobSearch, ActiveJobs, Loading, JobDetails } from "components";
import { Switch } from "react-router-dom";
import "./activitypage.less";

class JobsPage extends Component {
  static getStores() {
    return [FairStore, JobStore];
  }

  static calculateState() {
    var jobs = JobStore.getActiveJobs();
    var loading = JobStore.isLoading();
    var background = JobStore.getBackground();
    var filters = JobStore.getActiveFilters();
    var title = FairStore.getFairTitle(_("Jobs"));
    let fairData = FairStore.getFairData();
    let isFairActive = fairData
      ? fairData.active
        ? fairData.active
        : false
      : false;
    let showFilter = fairData ? fairData.jobsFilterEnabled : 0;

    return {
      loading: loading,
      jobs: jobs,
      title: title,
      background: background,
      isFairActive,
      showFilter,
      filters: filters,
    };
  }

  componentDidMount() {
    let params = new URLSearchParams(this.props.location.search);
    Creators.setJobFilters({
      positions: params.getAll("positions"),
      categories: params.getAll("categories"),
      locations: params.getAll("locations"),
      companies: params.getAll("companies"),
    });
    Creators.loadJobs();
  }

  componentDidUpdate(prevProp, prevState) {
    if (prevState.filters != this.state.filters) {
      const params = this.state.filters;
      const existingSearchParams = new URL(document.location).searchParams;
      const urlParams = new URLSearchParams();
      for (const i in params) {
        existingSearchParams.delete(i);
        if (!params[i].length) continue;
        params[i].forEach((value) => {
          urlParams.append(i, value);
        });
      }

      existingSearchParams.forEach((value, key) => {
        urlParams.append(key, value);
      });

      console.log("REDIRECTING");

      this.props.history.push(`?${urlParams.toString()}`);
    }
  }

  render() {
    var {
      title,
      jobs,
      background,
      details,
      isFairActive,
      showFilter,
    } = this.state;

    App.setPageTitle(title);

    var style = {};

    if (background) {
      style.backgroundImage = App.url(background);
    }

    return (
      <div className="page jobs activity">
        <div className="menu">
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <Back />
          </nav>
        </div>
        <div className="container">
          <div className="background">
            <div style={style}></div>
          </div>
          <div className="content">
            <div className="col-md-12">
              <Switch>
                <Route
                  exact={true}
                  path="/jobs/:jobId"
                  render={({ match }) => (
                    <div>
                      <JobDetails />
                    </div>
                  )}
                />

                <Route
                  path="/jobs"
                  render={() => (
                    <div>
                      <h1 className="display-5">{_("Jobs")}</h1>
                      {0 ? (
                        <div className="alert alert-info" role="alert">
                          <div>
                            <strong>{_("Note")}:</strong>
                          </div>
                          <div>
                            {_(
                              "Simple application to multiple positions available"
                            )}
                          </div>
                        </div>
                      ) : null}
                      {showFilter ? <JobSearch /> : null}
                      <ActiveJobs
                        data={jobs}
                        baseUrl="/jobs/"
                        isFairActive={isFairActive}
                      />
                    </div>
                  )}
                />
              </Switch>
            </div>
          </div>
          <Loading visible={jobs == null} description={_("Loading") + "..."} />
        </div>
      </div>
    );
  }
}

export default Container.create(JobsPage);



// WEBPACK FOOTER //
// ./src/modules/pages/jobpage.js